import styled from "styled-components";

export const PhoneContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  font-family: "Geist", sans-serif;

  .phone-row {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .phone-row .react-tel-input {
    flex: 1;
    min-width: 0;
    font-family: "Geist", sans-serif;
  }

  .phone-row .react-tel-input .form-control {
    width: 100%;
    height: 40px;
    padding-left: 80px;
    border: 0.909px solid rgba(0, 0, 0, 0.09);
    border-radius: 16px;
    font-size: 14px;
    letter-spacing: -0.1px;
    color: #181d27;
    box-shadow: none;
  }

  .phone-row .react-tel-input .form-control.is-invalid {
    border-color: #b42318;
  }

  .phone-row .react-tel-input .flag-dropdown {
    border: none;
    border-right: 1px solid rgba(0, 0, 0, 0.06);
    border-radius: 16px 0 0 16px;
    background: transparent;
  }

  .phone-row .react-tel-input .selected-flag {
    width: 68px;
    padding-left: 14px;
    border-radius: 16px 0 0 16px;
  }

  .status {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: -0.1px;
  }

  .status.verified {
    color: #316434;
  }

  .status.unverified {
    color: #b54708;
  }

  .code-row {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .code-row input {
    width: 140px;
    height: 40px;
    padding: 0 12px;
    border: 0.909px solid rgba(0, 0, 0, 0.09);
    border-radius: 8px;
    font-family: "Geist", sans-serif;
    font-size: 14px;
    letter-spacing: -0.1px;
  }

  .code-row input:focus {
    outline: none;
    border-color: #181d27;
  }

  .field-error {
    font-size: 12px;
    line-height: 18px;
    color: #b42318;
  }

  @media (max-width: 768px) {
    .phone-row {
      flex-wrap: wrap;
    }
  }
`;
